import { client } from './client';

// eslint-disable-next-line object-shorthand

export const weeklySchedule = () => client.get('deposits/weekly_schedule.json');
